import { AppType, BillingPeriod, Currency, FlowType, UserAddressForm } from 'apps-common/types';
import { TrackingPaymentMethodTypes } from 'apps-common/utils/analytics';
import { ExtendableError } from 'apps-common/utils/ExtendableError';

import { CreditCardCallbackPage } from './CreditCardCallbackPage';
import { PaypalCallbackPage } from './PaypalCallbackPage';

export interface PaymentMethodCallbackTrackingData {
  paymentMethodType: TrackingPaymentMethodTypes;
  currency: Currency;
  locale: string;
  billingPeriod: BillingPeriod;
  paymentGateway: string;
}

export class PaymentCallbackError extends ExtendableError {
  code: string;

  constructor(message: string, code: string, errorOptions?: ErrorOptions) {
    super(message, errorOptions);
    this.code = code;
    this.name = 'PaymentCallbackError';
  }

  static is(error: unknown): error is PaymentCallbackError {
    return error instanceof PaymentCallbackError;
  }

  static fromUnknown(error: unknown, defaultCode = 'UNKNOWN_ERROR'): PaymentCallbackError {
    if (PaymentCallbackError.is(error)) return error;
    const message = error instanceof Error ? error.message : String(error);
    return new PaymentCallbackError(message, defaultCode);
  }
}

export type OnPaymentMethodCallbackSuccessHandler = (
  flowType: FlowType,
  email: string,
  userAddressForm: UserAddressForm,
  paymentMethodId: string,
  completeRoute: string,
  paymentMethodRoute: string,
  paymentMethodCallbackTrackingData: PaymentMethodCallbackTrackingData,
) => Promise<void>;

export type OnPaymentMethodCallbackErrorHandler = (
  paymentMethodRoute: string,
  error: PaymentCallbackError,
  appType: AppType,
  paymentMethodCallbackTrackingData: PaymentMethodCallbackTrackingData,
) => void;

export interface PaymentMethodCallbackPageProps {
  appType: AppType;
  setPaymentError: (error: Error) => void;
  paymentMethodRoute: string;
  completeRoute: string;
  renewCompleteRoute?: string;
  billingPeriod?: BillingPeriod;
  currency?: Currency;
  email: string;
  userAddressForm: UserAddressForm;
  isUnitedStates?: boolean;
  paypalPaymentGatewayName?: string;
  onSuccess: OnPaymentMethodCallbackSuccessHandler;
  onError: OnPaymentMethodCallbackErrorHandler;
}

export { CreditCardCallbackPage, PaypalCallbackPage };
